import React, { useEffect, useMemo } from 'react';
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from './app/hook';
import TopNavigation from './components/navigation/TopNavigation';
import ExperiencePage from './components/pages/ExperiencePage';
import HomePage from './components/pages/HomePage';
import PaperPage from './components/pages/PaperPage';
import PDFPage from './components/pages/PDFPage';
import ProjectPage from './components/pages/ProjectPage';
// import TestPage from './components/pages/TestPage';
// import ExamplesPage from './components/pages/ExamplesPage';



function App(props) {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  return (
    <>
      <TopNavigation {...props} />
      <Routes>
        <Route path='/' element={<HomePage />} >


        </Route>
        <Route path='archive' element={<PaperPage />} />
        <Route path='pdf' element={<PDFPage />} />
        <Route path='experience' element={<ExperiencePage />} />
        <Route path='project' element={<ProjectPage />} />
        {/* <Route path='test' element={<TestPage />} />
        <Route path='examples' element={<ExamplesPage />} /> */}
      </Routes>
    </>


  );
}

export default App;
